import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Header from '../components/header';
import Footer from '../components/footer';
import MainSection from '../components/MainSection';
import { Helmet } from "react-helmet";
import { color } from 'framer-motion';

import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { auth } from "../firebaseConfig"; // adjust path if needed



const AdsDialog = ({ dialogShow, url_img, onClose }) => {
    if (dialogShow !== 1) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.dialog}>
                <button style={styles.closeButton} onClick={onClose}>
                    ×
                </button>
                <img src={url_img} alt="Ad" style={styles.image} />
            </div>
        </div>
    );
};


const LoginPage = () => {


    const [dialogShow, setDialogShow] = useState(0);
    const [url_img, setUrl_img] = useState('');

    const [oneTime, setOneTime] = useState(true);


    const [videoLink, setvideoLink] = useState("");
    const videoRef = useRef(null);


    const [emailOrPhone, setEmailOrPhone] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [show, setShow] = useState(false);
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const user = localStorage.getItem('user');
        if (user) {
            navigate('/home');
        }
    }, [navigate]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handlePassClose = () => setShowPasswordModal(false);
    const handlePassShow = () => setShowPasswordModal(true);




    const fetchUrl = async () => {
        const params = new URLSearchParams();
        params.append("table_name", "status");

        try {
            const source = axios.CancelToken.source();
            const timeout = setTimeout(() => {
                source.cancel();
            }, 20000); // 20 seconds timeout

            const response = await axios.post(
                "https://api.betprowallet.pk/ft_status.php",
                params,
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    cancelToken: source.token,
                }
            );

            clearTimeout(timeout);

            if (
                response.data &&
                typeof response.data === "string" &&
                response.data.startsWith("0 results")
            ) {
                return null;
            }

            if (response.data.length > 0) {

                setvideoLink(response.data[0].youtube_link);

                if (response.data[0].dialogShow_off) {


                    if (oneTime) {
                        setDialogShow(Number(response.data[0].dialogShow_off));
                        setUrl_img(response.data[0].img_ads_url);
                        setOneTime(false)
                    }


                } else {
                    setDialogShow(0);
                }




            }
        } catch (error) {
            if (axios.isCancel(error)) {
                // console.log("Request canceled", error.message);
            } else {
                // console.error("Error fetching user data", error);
            }
        }
    };


    useEffect(() => {
        if (videoLink && videoRef.current) {
            videoRef.current.load(); // reload video when link updates
        }
    }, [videoLink]);



    useEffect(() => {

        fetchUrl();

    }, []);





    const validateInput = (emailOrPhone, password) => {
        if (emailOrPhone.length === 11 && password !== "") {
            if (password.length >= 7) {
                return true; // Valid number and password
            } else {
                setError('Password is incorrect. It must be at least 7 characters long.');
                return false;
            }
        } else if (emailOrPhone.includes('@') && password !== "") {
            if (emailOrPhone.includes('.com') || emailOrPhone.includes('.Com') || emailOrPhone.includes('.COM')) {
                if (emailOrPhone.includes('gmail') || emailOrPhone.includes('Gmail') || emailOrPhone.includes('GMAIL')) {
                    if (password.length >= 7) {
                        return true; // Valid email and password
                    } else {
                        setError('Password is incorrect. It must be at least 7 characters long.');
                        return false;
                    }
                } else {
                    setError('Invalid email domain.');
                    return false;
                }
            } else {
                setError('Invalid email format.');
                return false;
            }
        } else {
            if (emailOrPhone.length >= 11 || emailOrPhone.includes('@')) {
                setError('Invalid number or email format.');
            } else if (password === "" || password.length < 7) {
                setError('Password is required and must be at least 7 characters long.');
            } else if (!emailOrPhone.includes('@')) {
                setError('Invalid number or email format.');
            }
            return false;
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        if (!validateInput(emailOrPhone, password)) {
            setLoading(false);
            handleShow();
            return;
        }

        const userField = emailOrPhone.length === 11 && !emailOrPhone.includes('@') ? 'user_number' : 'user_email';

        const params = new URLSearchParams();
        params.append('username', emailOrPhone);
        params.append('real_pass', password);
        params.append('fieldName', userField);
        params.append('table_name', 'users');

        try {
            const source = axios.CancelToken.source();
            const timeout = setTimeout(() => {
                source.cancel();
            }, 20000); // 20 seconds timeout

            const response = await axios.post('https://api.betprowallet.pk/loginUserApi_ft.php', params, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                cancelToken: source.token,
            });

            clearTimeout(timeout);


            if (response.data.message === '0 results') {
                setError('Your email or phone number, or password is incorrect. Please try again.');
                handleShow();
            } else {




                // Check if response starts with "0 results"
                if (response.data && typeof response.data === 'string' && response.data.startsWith('0 results')) {
                    setError('User not found. Please try again.');
                    handleShow();
                } else {



                    if (response.data[0].user_blocked === '0') {

                        localStorage.removeItem('user');

                        const user = {
                            name: response.data[0]?.user_fullname || 'User',
                            bp_username: response.data[0]?.user_betpro_username || '',
                            bp_pass: response.data[0]?.user_betpro_password || '',
                            email: response.data[0]?.user_email || '',
                            password: '',
                            number: response.data[0]?.user_whatsapp || 'N/A',
                            userID: response.data[0]?.user_id || 'N/A',
                            userActive: response.data[0]?.user_active || 0,
                            withdrawAmount: response.data[0]?.withdraw_amount || 25000,
                        };




                        localStorage.setItem('user', JSON.stringify(user));
                        navigate('/home');

                    } else {

                        setError('User not found. Your email, phone number or password is incorrect.');
                        handleShow();

                    }


                }



            }

        } catch (error) {
            if (axios.isCancel(error)) {
                setError('Request timed out. Please try again.');
            } else {
                setError('Please check your internet connection...');
            }
            handleShow();

            // console.log(error);
        } finally {
            setLoading(false);
        }

    };

    const handleForgotPassword = (e) => {
        e.preventDefault();
        handlePassClose();
        // console.log('Password reset email should be sent here.');
    };


    // Helper: Detect if user is inside WebView
    const isWebView = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /wv|WebView|; wv/.test(userAgent);
    };

    const handleGoogleLogin = async () => {
        if (isWebView()) {
            console.log("Detected WebView → using native Google sign-in");
           
            window.ReactNativeWebView?.postMessage(JSON.stringify({ action: "googleLogin", mode: "login" }));
           
            // The WebView app will intercept this message and handle login natively.
        } else {
            console.log("Detected Browser → using web OAuth flow");

            setLoading(true);
            setError('');


            try {
                const provider = new GoogleAuthProvider();
                // 👇 Force showing the account selection popup every time
                provider.setCustomParameters({
                    prompt: "select_account",
                });

                const result = await signInWithPopup(auth, provider);
                const user = result.user;

                const userData = {
                    name: user.displayName,
                    email: user.email,
                    number: user.phoneNumber || "UNKNOWN",
                    photo: user.photoURL,

                };

                setLoading(true);
                setError('');

                const params = new URLSearchParams();
                params.append('username', user.email);
                params.append('real_pass', user.uid);
                params.append('fieldName', 'user_email');
                params.append('table_name', 'users');

                // We only use Firebase to obtain the Google identity; our own
                // session lives in localStorage. Sign out of Firebase so it
                // doesn't keep persisting this session and silently
                // re-validating it (extra Identity Toolkit calls) on every
                // later visit to the Login/Signup pages.
                signOut(auth).catch(() => {});

                try {
                    const source = axios.CancelToken.source();
                    const timeout = setTimeout(() => {
                        source.cancel();
                    }, 20000); // 20 seconds timeout

                    const response = await axios.post('https://api.betprowallet.pk/loginUserApi_ft.php', params, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        cancelToken: source.token,
                    });

                    clearTimeout(timeout);


                    if (response.data.message === '0 results') {
                        setError('Your email or phone number, or password is incorrect. Please try again.');
                        handleShow();
                    } else {




                        // Check if response starts with "0 results"
                        if (response.data && typeof response.data === 'string' && response.data.startsWith('0 results')) {
                            setError('User not found. Please try again.');
                            handleShow();
                        } else {



                            if (response.data[0].user_blocked === '0') {

                                localStorage.removeItem('user');

                                const user = {
                                    name: response.data[0]?.user_fullname || 'User',
                                    bp_username: response.data[0]?.user_betpro_username || '',
                                    bp_pass: response.data[0]?.user_betpro_password || '',
                                    email: response.data[0]?.user_email || '',
                                    password: '',
                                    number: response.data[0]?.user_whatsapp || 'N/A',
                                    userID: response.data[0]?.user_id || 'N/A',
                                    userActive: response.data[0]?.user_active || 0,
                                    withdrawAmount: response.data[0]?.withdraw_amount || 25000,
                                };


                                localStorage.setItem('user', JSON.stringify(user));
                                navigate('/home');

                            } else {

                                setError('User not found. Your email, phone number or password is incorrect.');
                                handleShow();

                            }


                        }



                    }

                } catch (error) {
                    if (axios.isCancel(error)) {
                        setError('Request timed out. Please try again.');
                    } else {
                        setError('Please check your internet connection...');
                    }
                    handleShow();

                    // console.log(error);
                } finally {
                    setLoading(false);
                }



                // console.log("Google user data:", user);
                // 🔹 You can now send userData to your backend API (signup/login)
            } catch (error) {
                  setError('Request timed out. Please try again.');
                 setLoading(false);
                    handleShow();
                //   console.error("Google sign-in error:", error);
            }
        }
    };


useEffect(() => {
  const handleMessage = async (event) => {

    console.log("🔥 REACT RECEIVED RAW:", event.data);

    let data = null;

    // ✅ CASE 1: Android sent JS object
    if (typeof event.data === "object" && event.data !== null) {
      data = event.data;
    }

    // ✅ CASE 2: Android / others sent JSON string
    else if (typeof event.data === "string") {

      // Ignore Firebase internal messages like "!_{}"
      if (!event.data.trim().startsWith("{")) {
        console.log("⏭ Ignored non-JSON string");
        return;
      }

      try {
        data = JSON.parse(event.data);
      } catch (e) {
        console.log("⏭ JSON parse failed");
        return;
      }
    }

    if (!data?.email || !data?.uid) {
      console.log("⏭ Missing required fields");
      return;
    }

    console.log("✅ ANDROID USER DATA:", data);

    try {

      /* ===========================
         🔐 LOGIN
      =========================== */
      if (data.mode === "login") {
        const params = new URLSearchParams();
        params.append("username", data.email);
        params.append("real_pass", data.uid);
        params.append("fieldName", "user_email");
        params.append("table_name", "users");

        const response = await axios.post(
          "https://api.betprowallet.pk/loginUserApi_ft.php",
          params,
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        );

        if (response.data && response.data[0]) {
          const user = {
            name: response.data[0].user_fullname,
            bp_username: response.data[0].user_betpro_username,
            bp_pass: response.data[0].user_betpro_password,
            email: response.data[0].user_email,
            number: response.data[0].user_whatsapp,
            userID: response.data[0].user_id,
            userActive: response.data[0].user_active,
            withdrawAmount: response.data[0].withdraw_amount || 25000,
          };

          localStorage.setItem("user", JSON.stringify(user));
          navigate("/home");
          return;
        }

        setError("User not found");
        setShowErrorModal(true);
        return;
      }

      /* ===========================
         📝 SIGNUP
      =========================== */
      if (data.mode === "signup") {
        const params = new URLSearchParams();
        params.append("user_email", data.email);
        params.append("user_whatsapp", "UNKNOWN");
        params.append("user_fullname", data.name || "User");
        params.append("user_real_pass", data.uid);
        params.append("table_name", "users");

        const response = await axios.post(
          "https://api.betprowallet.pk/createNewAccUserFromServer.php",
          params,
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        );

        if (response.data?.status === "success") {
          const u = response.data.data[0];

          const user = {
            name: u.user_fullname,
            bp_username: u.user_betpro_username,
            bp_pass: u.user_betpro_password,
            email: u.user_email,
            number: u.user_whatsapp,
            userID: u.user_id,
            userActive: u.user_active,
            withdrawAmount: u.withdraw_amount || 25000,
          };

          localStorage.setItem("user", JSON.stringify(user));
          navigate("/home");
          return;
        }

        setError(response.data?.message || "Signup failed");
        setShowErrorModal(true);
      }

    } catch (err) {
      console.error("❌ Google Auth API Error:", err);
      setError("Something went wrong. Please try again.");
      setShowErrorModal(true);
    }
  };

  console.log("✅ React listener mounted");

  document.addEventListener("message", handleMessage);
  window.addEventListener("message", handleMessage);

  return () => {
    document.removeEventListener("message", handleMessage);
    window.removeEventListener("message", handleMessage);
  };
}, []);



    return (
        <div>

            {/* Use Helmet to dynamically set the title and meta description */}
            {/* <Helmet> */}
            {/* Page title with relevant keywords */}
            {/* <title>Betpro Wallet Login - Bpexch</title> */}

            {/* <link rel="icon" href="https://betprowallet.pk/favicon.ico" /> */}


            {/* Canonical tag */}
            {/* <link rel="canonical" href="https://betprowallet.pk/" /> */}

            {/* Meta description to summarize the page content with optimized keywords */}
            {/* <meta name="description" content="Betpro Wallet mobile login✔️ Secure Betpro Wallet login ⚽️ Quick access to Betpro Wallet APP login ✅ Sign in to bet and win real money with Betprowallet.pk. Fast withdrawals and 24/7 customer support." /> */}



            {/* Meta keywords to target top-ranking search queries */}
            {/* <meta name="keywords" content="Betpro Wallet login, Betpro Wallet sign in, Betpro Wallet mobile login, Betpro Wallet APP login, Betpro Wallet account access, secure login, online betting in Pakistan, Betprowallet.pk login" /> */}

            {/* Meta author */}
            {/* <meta name="author" content="Betpro Wallet" /> */}



            {/* Open Graph meta tags for social media sharing */}
            {/* <meta property="og:title" content="Betpro Wallet Login - Bpexch" />
  <meta property="og:description" content="Sign in to Betpro Wallet securely. Quick access to Betpro Wallet APP login and start betting on sports today with fast payouts and bonuses." />
  <meta property="og:url" content="https://betprowallet.pk" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://betprowallet.pk/bpthumb1.jpg" /> */}

            {/* Twitter Card for better social sharing */}
            {/* <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Betpro Wallet Login - Bpexch" />
  <meta name="twitter:description" content="Secure Betpro Wallet login. Access your account via mobile or app and bet on your favorite sports with Betpro Wallet. Sign in now at Betprowallet.pk!" />
  <meta name="twitter:image" content="https://betprowallet.pk/images/login-twitter-image.jpg" /> */}

            {/* Structured Data for SEO */}
            {/* <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Betpro Wallet Login - Bpexch",
        "url": "https://betprowallet.pk",
        "description": "Betpro Wallet Sign In page. Log in securely and access your betting account to place bets, win real money, and get fast payouts.",
        "publisher": {
          "@type": "Organization",
          "name": "Betpro Wallet"
        }
      }
    `}
  </script> */}
            {/* </Helmet> */}

            <Header />
            <div className="login-wrapper2">
                <div className="main-login">
                    <div className="container" style={{ padding: "0 1rem", maxWidth: "28rem" }}>
                        <div className="row align-items-top">
                            <div className="col-md-12">
                                <div className="left-login-box">
                                    <div className="fieldset"

                                        style={{
                                            padding: '10px 0px',
                                        }} >
                                        <div className="title mb-5">
                                            <h2>Login to Betpro wallet</h2>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <div className="inputs field-container">
                                                    <form onSubmit={handleSubmit}>
                                                        <input
                                                            type="text"
                                                            name="email"
                                                            // className="mb-4"
                                                            placeholder="Email or phone number"
                                                            value={emailOrPhone}
                                                            onChange={(e) => setEmailOrPhone(e.target.value)}
                                                            required
                                                        />
                                                        <input
                                                            type="password"
                                                            name="password"
                                                            // className="mb-4"
                                                            placeholder="Enter password"
                                                            value={password}
                                                            onChange={(e) => setPassword(e.target.value)}
                                                            required
                                                        />
                                                        <button type="submit" className="btn-signin mb-3" disabled={loading}>
                                                            {loading ? 'Loading...' : 'Sign in'}
                                                        </button>
                                                    </form>
                                                    <div className="forgot-password">
                                                        <a onClick={handlePassShow}>Forgot password?</a>
                                                    </div>
                                                    <a href="/signup" className="signup mb-3">
                                                        Don't have an account?
                                                    </a>
                                                    <button className="btn-create-account mb-3" onClick={() => navigate('/signup')}>
                                                        Create account
                                                    </button>

                                                    <button className="btn-google-login" onClick={handleGoogleLogin}>
                                                        <img
                                                            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                                                            alt="Google logo"
                                                            className="google-icon"
                                                        />
                                                        Continue with Google
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>





                    </div>


                </div>



            </div>

            {Number(dialogShow) == 1 ?
                <>
                    <AdsDialog dialogShow={dialogShow} url_img={url_img} onClose={() => setDialogShow(0)} />  </> : null

            }

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header >
                    <Modal.Title>Sign in Failed!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{error}</p>
                    <hr />
                    <p onClick={handleClose} className="model-ok">Ok</p>
                </Modal.Body>
            </Modal>

            <Modal show={showPasswordModal} onHide={handlePassClose} centered>
                <Modal.Header >
                    <Modal.Title >Forgot Password?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>You will receive instructions for resetting your password.</p>
                    <form onSubmit={handleForgotPassword}>
                        <div className='forgotinputs'>
                            <input type="text" placeholder="Email or phone number" required />
                            <button type="submit" className="btn-signin" style={{ marginTop: "15px" }}>Send my Password</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>


            <MainSection />



            <div className="container text-center" style={{ padding: "0 1rem", maxWidth: "28rem", marginBottom: "150px" }}>
                <h5>How to active Betpro 🆔</h5>
                <div
                    style={{
                        position: "relative",
                        paddingBottom: "56.25%",
                        height: 0,
                        overflow: "hidden",
                        maxWidth: "100%",
                        backgroundColor: "#000",
                    }}
                >
                    <video
                        ref={videoRef}
                        controls
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                        }}
                    >
                        <source src={videoLink} type={"video/mp4"} />

                        {console.log(videoLink)}



                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>



            <Footer />
        </div>
    );
};


const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "10000"
    },
    dialog: {
        position: "relative",
        backgroundImage: "linear-gradient(#2E506C, #152337)",
        padding: "20px 15px",
        borderRadius: "8px",
        textAlign: "center",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    },
    closeButton: {
        position: "absolute",
        top: "0px",
        right: "15px",
        fontSize: "30px",
        background: "none",
        color: "white",

        border: "none",
        cursor: "pointer",
    },
    image: {
        marginTop: "20px",
        width: "100%",
        height: "auto",
        maxWidth: "300px",
        borderRadius: "8px",
    },
    button: {
        padding: "10px 20px",
        fontSize: "16px",
        cursor: "pointer",
        backgroundColor: "#007bff",
        color: "white",
        border: "none",
        borderRadius: "5px",
    },
};


export default LoginPage;
